// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2VqOL","visuallyhidden":"_38OzZ","hide-text":"_2Mdsy","center":"loAdN","noprint":"_3tDzk","root":"_2R-3T","contentContainer":"_17Lc9","noA":"_2aGcc"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theme/article/default.scss
 ** module id = 976
 ** module chunks = 2
 **/